<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El fuerte de Loreto</h2>
    <img @click="imageClicked(0)" src="galerias/sala3/S3_G4.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Fachada Interior del Fuerte de Loreto</b><br>
      Técnica: Fotografía digital<br>
      Colección: INAH<br>
    </p>
    <p>El fuerte de Loreto, al igual que el fuerte de Guadalupe, fue adaptado para defender la ciudad, sin embargo, su construcción es más antigua. Fue utilizado por primera vez durante la Guerra de Independencia en 1817 como polvorín del ejército Virreinal.</p>
    <p>Desde 1655 en este lugar se construyó un templo dedicado a la Virgen de Loreto.</p>
    <p>Durante el enfrentamiento contra el ejército francés, sirvió para resguardo de la artillería mexicana.</p>
    <p>Actualmente se encuentra rehabilitado y alberga el Museo de la No Intervención. Al interior de la muralla que lo rodea todavía se distingue la fachada del que alguna vez fue el Templo de Loreto.</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, para conocer más de la historia de este sitio visita:<br>
      <a target="_blank" href="https://mediateca.inah.gob.mx/islandora_74/islandora/object/museo%3A1552">mediateca.inah.gob.mx</a>
    </p>

    <h3>El fuerte de Loreto</h3>
    <img @click="imageClicked(1)" src="galerias/sala3/S3_SubG4.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Vista parcial del Fuerte de Loreto</b><br>
      Autor: Agustín Víctor Casasola<br>
      Año: 1962<br>
      Técnica: Fotografía<br>
      Colección Fototeca Nacional<br>
    </p>
    <p>En esta fotografía tomada por Agustín Víctor Casasola se muestran las ruinas del Fuerte de Loreto hacia el año 1962. Se aprecia la original estructura que tenía la iglesia, con dos pequeñas torres laterales y una portada de estilo barroco rematada por 3 nichos.</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, alojada en: <a target="_blank" href="http://mediateca.inah.gob.mx/repositorio/islandora/object/fotografia%3A196146">mediateca.inah.gob.mx</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "s32g04",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
